import { EmitterSubscription } from "react-native";

let subscriptions: EmitterSubscription[] = [];

export const revokeSoundPlayerSubscriptions = () => {
}

export const initSoundPlayerSubscriptions = () => {
}